import axios from "axios";
import join from "lodash/join";
import split from "lodash/split";
import indexOf from "lodash/indexOf";
import forEach from "lodash/forEach";

import { MORTGAGE_BROKER, BORROWER } from "../constants/contact_id_status";
import { adminUrl, PAGES, SET_PAGE } from "../config/constants";

export const submitPassword = (values) => async (dispatch, getState) => {
  const { isNewUser, userId } = getState().user;
  const { contacts } = getState().form;

  const formData = new FormData();

  formData.append("action", "submitPassword");
  formData.append("isNewUser", isNewUser);
  formData.append("pms_password", values.pms_password);

  let phone_mobile = contacts.phone_mobile;

  phone_mobile = join(split(phone_mobile, " "), "");
  phone_mobile = join(split(phone_mobile, "-"), "");
  phone_mobile = join(split(phone_mobile, "("), "");
  phone_mobile = join(split(phone_mobile, ")"), "");

  formData.append("phone_mobile", phone_mobile);

  const fieldForBroker = [
    "area_you_service",
    "appropriate_licensing",
    "bridge_financing_per_yr",
    "bridge_financing_per_month",
  ];

  forEach(contacts, (val, field) => {
    if (field !== "phone_mobile") {
      if (
        contacts.id_status === BORROWER.value &&
        indexOf(fieldForBroker, field) !== -1
      ) {
      } else {
        formData.append(field, val);
      }
    }
  });

  if (isNewUser === false) {
    formData.append("id", userId);
  }

  if (contacts.id_status === BORROWER.value) {
    dispatch({
      type: SET_PAGE,
      payload: PAGES.BORROWER_CREDIT,
    });
  } else {
    dispatch({
      type: SET_PAGE,
      payload: PAGES.BORROWER_INFO2,
    });
  }

  const { data } = await axios.post(adminUrl, formData);

  dispatch({
    type: "SET_USER",
    payload: {
      userId: data.id,
    },
  });

  //
};



// WEBPACK FOOTER //
// ./src/actions/submitPassword.actions.js